import { getSlot } from "@/mds/utils/slots";
import { MDSPanelHeaderSlotName } from "../panel-header/panel-header.types";
import { MDSSidePanelHeaderProps } from "./side-panel-header.types";
import { StyledWrapper } from "./side-panel-header.style";

export const MDSSidePanelHeader = ({
  children,
  backgroundColor,
  bottomBorderColor,
  onClick,
  onMouseEnter,
  onMouseLeave,
  isDisabled,
}: MDSSidePanelHeaderProps) => {
  const headingSlot = getSlot(children, MDSPanelHeaderSlotName.Heading);
  const actionsSlot = getSlot(children, MDSPanelHeaderSlotName.Actions);
  const hasOnClick = Boolean(onClick);

  return (
    <StyledWrapper
      data-component="MDSSidePanelHeader"
      as={hasOnClick ? "button" : "div"}
      {...(hasOnClick && { onClick, disabled: isDisabled, "aria-disabled": isDisabled })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      $backgroundColor={backgroundColor}
      $bottomBorderColor={bottomBorderColor}
      $hasOnClick={hasOnClick}
    >
      {headingSlot}
      {actionsSlot}
    </StyledWrapper>
  );
};
